import { range, shuffle } from 'lodash';

const drawLotNumbers = count => shuffle(range(count)).map(i => i + 1);

export default drawLotNumbers;



// WEBPACK FOOTER //
// ./src/pages/Entry/drawLotNumbers.js